import { roomDetails } from '@/constants/rooms'
import { packageItems } from '@/constants/packages'
import { articles } from '@/constants/articles'

export type Testimonial = { name: string, avatar: string, quote: string }

export const heroImage = {
    src: '/images/greenbrier/inn-exterior-1.jpg',
    alt: "The Greenbrier Inn and Gift Shop on Route 4 in Killington, Vermont"
}

/** Cards on the home page read from the room pages' own data. */
export const rooms = roomDetails.map((room) => ({
    slug: room.slug,
    name: room.name,
    size: room.size,
    bed: room.bed,
    image: room.cardImage,
    imageAlt: room.cardImageAlt,
    description: room.cardDescription
}))

export const services = [
    {
        index: '01',
        title: "Continental Breakfast",
        tags: ["Breakfast", "Morning coffee"],
        image: '/images/greenbrier/inn-lobby-4-a.jpg',
        imageAlt: "Coffee bar in the Greenbrier Inn lounge with plaid stools and a Killington ski poster",
        description: "Start the day with a continental breakfast and enjoy your morning coffee at the bar in our lounge."
    },
    {
        index: '02',
        title: "Lounge by the Fire",
        tags: ["Hot chocolate", "Games", "Books"],
        image: '/images/greenbrier/inn-lobby-3.jpg',
        imageAlt: "Lounge with floral sofas, a bookcase and a wood stove at the Greenbrier Inn",
        description: "Enjoy a cup of hot chocolate in our lounge by the fire. Play games, read a book, or just take it easy."
    },
    {
        index: '03',
        title: "Outdoor Pool",
        tags: ["Summer", "Mountain views"],
        image: '/images/greenbrier/inn-pool2.jpg',
        imageAlt: "Outdoor pool on the lawn at the Greenbrier Inn with fall foliage and mountains behind",
        description: "Our outdoor swimming pool is open in the summer, with the Green Mountains all around."
    },
    {
        index: '04',
        title: "Trails & Trout Stream",
        tags: ["Hiking", "Snowshoeing", "Trout stream"],
        image: '/images/greenbrier/inn-stream2.jpg',
        imageAlt: "Trout stream tumbling over mossy rocks and fallen leaves",
        description: "Hike our trails and take a walk along the trout stream, then swap boots for snowshoes when the snow arrives."
    }
]

export const locationStats = [
    {
        value: '05',
        lines: ["miles to the", "Killington ski lifts"],
        media: {
            type: 'image' as const,
            src: '/images/greenbrier/inn-lobby-5.jpg',
            alt: "Wooden coffee bar in the inn's lounge with a Ski Killington Vermont poster"
        }
    },
    {
        value: '02',
        lines: ["miles to Green Mountain", "National Golf Course"],
        media: {
            type: 'image' as const,
            src: '/images/greenbrier/golf-green-mountain-national.jpg',
            alt: "Fairway and pond at Green Mountain National Golf Course"
        }
    },
    {
        value: '02',
        lines: ["miles to Killington’s", "restaurants, bars and nightlife"],
        media: {
            type: 'image' as const,
            src: '/images/greenbrier/inn-exterior-3.jpg',
            alt: "Snowy entrance of the Greenbrier Inn lit up on a winter evening"
        }
    },
    {
        value: '03',
        lines: ["hours by car from Boston,", "Hartford and Montreal"],
        media: {
            type: 'image' as const,
            src: '/images/greenbrier/inn-exterior-1.jpg',
            alt: "The Greenbrier Inn and Gift Shop on Route 4 in Killington, Vermont"
        }
    }
]

export const packages = packageItems

/** No published guest reviews yet, so the reviews band stays hidden. */
export const testimonials: Testimonial[] = []

/** Overall rating shown beside the reviews. Only set it from a real, published score. */
export const reviewSummary: { rating: string, label: string } | null = null

export const guestAvatars: string[] = []

export const partnerLogos: string[] = []

/** `rotate` is the tile's starting angle: it pops from scale(0.2) at that
 *  angle and settles upright, exactly as the original does. Captions are the
 *  inn's own photo captions. */
export const galleryStrip = [
    { image: '/images/greenbrier/giftshop-3.jpg', caption: "Jewelry, home decor and much more", rotate: -5 },
    { image: '/images/greenbrier/inn-stream1.jpg', caption: "Take a hike along our trout stream", rotate: 0 },
    { image: '/images/greenbrier/inn-room-2.jpg', caption: "One or two queen size beds", rotate: 5 },
    { image: '/images/greenbrier/giftshop-1.jpg', caption: "A unique gift shop", rotate: -2 },
    { image: '/images/greenbrier/inn-lobby-5-a.jpg', caption: "Relax by our fireplace", rotate: 1 }
]

/** Cards on the home page read from the news posts' own data. */
export const newsPosts = articles.slice(0, 3).map((article) => ({
    slug: article.slug,
    category: article.category,
    title: article.title,
    date: article.date,
    image: article.image,
    imageAlt: article.imageAlt
}))

export const chooseTiles = [
    {
        eyebrow: "Choose your",
        title: "Stay",
        href: '/#rooms',
        image: '/images/greenbrier/inn-room-1.jpg',
        imageAlt: "Guest room with one queen bed, a sofa and a table with two chairs"
    },
    {
        eyebrow: "Discounted",
        title: "Lift Tickets",
        href: '/packages',
        image: '/images/greenbrier/slide-mountain.jpg',
        imageAlt: "Killington ski trails above a hillside of fall foliage"
    }
]
